export function ledOverlayStorageKey(slug) {
  return `led-overlay-${slug}`;
}

export function readLedOverlayId(storage, slug) {
  if (!storage || !slug) return null;
  const raw = storage.getItem(ledOverlayStorageKey(slug));
  const id = raw ? Number(raw) : null;
  if (!id || !Number.isFinite(id)) return null;
  return id;
}

export function writeLedOverlayId(storage, slug, id) {
  if (!storage || !slug) return;
  const key = ledOverlayStorageKey(slug);
  if (id) {
    storage.setItem(key, String(id));
    return;
  }
  storage.removeItem(key);
}
